module.exports = __webpack_public_path__ + "img/title-logo.8c10a5d6.png";